import AlertIcon from 'images/alert_outline_icon.svg'
import React from 'react'
import { mixinErrorMessageClasses } from 'spa/member/styles/mixin'
import { FormErrorMessageProps } from './types'

export const StyledFormErrorMessage: React.FC<FormErrorMessageProps> = props => {
  return (
    <div className={mixinErrorMessageClasses}>
      <img src={AlertIcon} alt="alert" />
      {props.message}
    </div>
  )
}
